import React from 'react';
import { useWMS2010_R01Store } from '../Store_WMS2010_R01';

interface SubtotalControlProps {
    className?: string;
}

export const SubtotalControl: React.FC<SubtotalControlProps> = ({ className = '' }) => {
    const { showSubtotals, setShowSubtotals } = useWMS2010_R01Store();
    const checkboxId = 'WMS2010_R01_showSubtotals';

    return (
        <div className={`flex items-center gap-2 px-4 py-1 ${className}`}>
            <label
                htmlFor={checkboxId}
                className="text-s cursor-pointer select-none"
            >
                품목 소계
            </label>
            <input
                id={checkboxId}
                type="checkbox"
                checked={showSubtotals}
                onChange={(event) => setShowSubtotals(event.target.checked)}
                className="h-4 w-4 cursor-pointer accent-blue-600"
            />
        </div>
    );
};
